window.addEventListener('alpine:init', bootstrap);

export default () => ({
	$header: null,
	header_visible: true,
	expanded: false,
	init() {
		this.$header = document.getElementById('site-header');
		this.setHeight();
	},
	setHeight() {
		let height = 0;
		if ( this.header_visible ) {
			height = this.$header.clientHeight;
		}
		document.body.style.setProperty('--header-height', height + 'px');
	}
});

function bootstrap() {
	const $main = document.getElementById('main');
	if ( !$main ) { return; }

	$main.setAttribute('x-data', 'headerSpace');
	// Debounce, not throttle: the header height is only meaningful once the resize has
	// settled, and setHeight reads clientHeight then writes a custom property, so every extra
	// call is a forced reflow. One binding only.
	$main.setAttribute('x-on:resize.window.debounce.100ms', 'setHeight');
}



